import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { ProductModel } from "./Product.model";
import { ComboBoxComponent } from "../../../combo-box/combo-box.component";
import { FormComponent } from "../../../form/form.component";
import { ServiceStock } from "../../../service-stock.service";

const customCss: string = "";

@Component({
  selector: "app-Product",
  templateUrl: "./Product.component.html",
})
export class ProductComponent
  extends FormComponent
  implements OnInit, AfterViewInit
{
  @Output() productSelected: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("cmbProduct", { static: false }) cmbProduct: ComboBoxComponent;
  @Input("displayLabel") displayLabel: boolean = true;
  skeletonContentLoaded = false;
  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([this.revalidateBasicField("cmbProduct")]).then(
      (errorCounts) => {
        errorCounts.forEach((errorCount) => {
          totalErrors += errorCount;
        });
      }
    );
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new ProductModel();
    this.componentCode = "Product";
    this.displayBorder = false;
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(
      this.services.dataStore.getData(this.services.routing.currModal)
    );
    //this.cmbProduct.setValue(this.services.dataStore.getData("productID"));
    this.cmbProduct.setValue(this.cmbProduct.dropDownOptions.Options[1]);
    this.cmbProduct.setReadOnly(false);
    this.setDependencies();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params["mode"]) {
      this.mode = params["mode"];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData["formName"] = "Product";
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach((field) => {
      this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
    });
    this.comboFields.forEach((field) => {
      this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
    });
    // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
    return this.additionalInfo;
  }
  getFieldValue() {
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.value = new ProductModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) {
      this.formCode = "Product";
    }
    if (this.formOnLoadError) {
      return;
    }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.innerHTML = customCss;
    styleElement.id = "Product_customCss";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById("Product_customCss");
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new ProductModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbProduct_change() {
    this.productSelected.emit({});
  }
  
  updateProductList(exch: string) {
    this.cmbProduct.dropDownOptions.Options =
      this.services.dataStore.getProductByExch(
        exch,
        this.cmbProduct.dropDownOptions,
        this.cmbProduct.placeholder
      );
    if (this.cmbProduct.dropDownOptions.Options[1] != null) {
      this.cmbProduct.setValue(this.cmbProduct.dropDownOptions.Options[1].id);
    }
  }
  fieldDependencies = {};
  setProductDropDown(){
   if (this.cmbProduct.dropDownOptions.Options[1] != null) {
      this.cmbProduct.setValue(this.cmbProduct.dropDownOptions.Options[1].id);
    }
  }
}